<template>
    <div>
        <div class="fw-bold" v-if="hasForm">
            <localized-text localizedKey="Form di acquisto" text="Form di acquisto"></localized-text>
        </div>
        <template v-if="hasForm">
            <div class="form-group" v-for="(value, key, i) in answers" :key="key">
                <label>{{key}}</label>
                <span class="form-control">
                    <template v-for="(item, i) in value">
                        {{item}}<template v-if="i < value.length - 1">,</template>
                    </template>
                </span>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import * as VM from '@/viewmodel';

@Options({})
export default class formAnswersViewer extends Vue {

    @Prop() answers: { [key: string]: string[] };

    hasForm: boolean = false;

    created(){
        this.init();
    }

    @Watch('answers')
    init(){
        if(this.answers){
            this.hasForm = Object.keys(this.answers).length > 0;
        } else {
            this.hasForm = false;
        }
    }
}

</script>
